export enum NewsRoutes {
  NEWS = '/novidades',
  NEWS_DEFAULT = '/novidades/colab-mais',
  CONFIRMATION_MULTI = '/novidades/multi-beneficios/recebemos-seu-interesse',
  REWARD_BENEFIT_CONFIRMATION = '/novidades/saldo-livre/recebemos-seu-interesse',
  PAYROLL_LOANS_CONFIRMATION = '/novidades/credito-consignado/recebemos-seu-interesse',
}
